<template>
    <div>
        <div class="one column row">
            <h1 class="margin-bottom-0 mt-30 main-title" v-cloak>{{blog.title}}</h1>
        </div>
        <div class="grey" v-cloak>
            <div class="social-container">
                <a :href="facebookURL" target="_blank">
                    <img src="/images/blog/fb.png" alt="Facebook icon">
                </a>
                <a :href="twitterURL" target="_blank">
                    <img src="/images/blog/twitter.png" alt="Twitter icon">
                </a>
                <a :href="`mailto:%20?subject=${subject}&body=${body}`">
                    <img src="/images/blog/mail.png" alt="Mail icon">
                </a>
            </div>
        </div>
        <div class="body" v-html="blog.body"></div>
        <div id="ocena" class="row">
            <blog-ocene  :blog="blog" :token="token"></blog-ocene>
        </div>
        <div class="row">
            <div class="sixteen wide column" v-if="hasGallery">
                <blog-gallery class="gallery" :data="blog.gallery"></blog-gallery>
            </div>
        </div>
        <div class="row">
            <p>
                <a :href="backUrl">
                    <button class="ui button back-btn">
                        Nazaj na seznam novic
                    </button>
                </a>
            </p>
        </div>
        <h1 id="komentarji" class="komentarji-header">Komentarji</h1>
        <div class="row">
            <blog-comments :blog="blog" :token="token"></blog-comments>
        </div>
        <h1 id="sorodne-vsebine" class="sorodne-vsebine-header">Sorodne vsebine</h1>
        <related-content :existing-blog="blog"></related-content>
    </div>
</template>

<script>
import BlogGallery from './BlogGallery'
import RelatedContent from './RelatedContent.vue'
import BlogComments from './BlogComments.vue'
import BlogOcene from './BlogOcene.vue'

export default {
	components: {
        BlogGallery,
        RelatedContent,
        BlogComments,
        BlogOcene
    },
    props: ['blog', 'token'],
	data() {
		return {
            facebookURL: undefined,
            twitterURL: undefined,
            linkedinURL: undefined,
            subject: undefined,
            body: undefined,
            iframeClass: undefined
		};
	},
    mounted() {
        this.generateURLs();
        this.bindIframe();
        this.sendURLPathToIframe();
        this.analitycsConsented = this.$cookies.get("analytics-consent") == null ? false : (this.$cookies.get("analytics-consent") == "true" ? true : false);
        if (this.analitycsConsented) {
            this.podcastNotPlayed = true;
            this.videoNotPlayed = true;
            this.onAudioPlay();
            this.onVideoPlay();
        }
    },
    destroyed() {
        this.unbindIframe();
            this.onAudioPlay({ destroy: true });
            this.onVideoPlay({ destroy: true });
    },
	methods: {
        onVideoPlay({ destroy = false } = {}) {
            // todo: use postMessage in bitmovin player in this.handleIframeMessage() function with domain s3-eu-west-1.amazonaws.com/rokus-video-transcode, when incorporated in the player

        },
        onAudioPlay({ destroy = false } = {}) {
            const audioTag = document.getElementsByTagName("audio");
            if (audioTag.length) {
                if (destroy) {
                    var videoTagArr = Array.prototype.slice.call( videoTag );
                    return videoTagArr.forEach(item => item.removeEventListener("play", this.pushAudioLayer.bind(this, item)));
                }
                var audioTagArr = Array.prototype.slice.call( audioTag );
                audioTagArr.forEach(item => item.addEventListener("play", this.pushAudioLayer.bind(this, item)));
            }
        },
        pushAudioLayer(item) {
            if (this.podcastNotPlayed) {
                _mtm.push({
                    "event": "audio-listened",
                    "naslov_bloga": this.blog && this.blog.title || "nedefinirano",
                    "audio_listened": item && item.src || "nedefinirano"
                });
                this.podcastNotPlayed = false;
            }
        },
        pushVideoLayer(item) {
            if (this.videoNotPlayed) {
                _mtm.push({
                    "event": "video-watched",
                    "naslov_bloga": this.blog && this.blog.title || "nedefinirano",
                    "video_watched": item && item.src || "nedefinirano"
                });
                this.videoNotPlayed = false;
            }
        },
        sendURLPathToIframe() {
            const iframe = document.getElementById("novice");
            if (!iframe) return;
            // iframe-u pošljemo url, za redirect po prijavi na novice
            setTimeout(() => {
                iframe.contentWindow.postMessage({
                    "type": "url",
                    "value": window.location.search
                }, "*");
            }, 5000);
        },
        bindIframe() {
            window.addEventListener('message', this.handleIframeMessage);
        },
        unbindIframe() {
            window.removeEventListener('message', this.handleIframeMessage);
        },
        handleIframeMessage(event) {
            if (event.origin.indexOf('https://survey.alchemer.eu') > -1) {
                const iframe = document.getElementById("novice");
                if (!iframe) return;
                if (!event.data || !event.data.type) return;

                // set css for iframe in parent scss
                if (event.data.type === "css" ) {
                    setTimeout(() => {
                        iframe.classList.add(event.data['value']);
                    }, 1000);
                // set calculated height of iframe
                } else if (event.data.type === "height") {
                    iframe.style.height = event.data['value'] + 'px';
                }
            }
        },
        generateURLs(event) {
            this.success = true;
            this.facebookURL =  'http://www.facebook.com/sharer/sharer.php?u=' + this.encodedURL + '&title=' + this.encodedTitle;
            this.twitterURL =  'https://twitter.com/intent/tweet?text=' + this.encodedTitle + '&url=' + this.encodedURL;
            this.linkedinURL = 'http://www.linkedin.com/sharing/share-offsite/?url=' + this.encodedURL
            this.subject = this.encodedTitle;
            this.body = this.encodedURL;
        },
        // funkcijo pustil notri samo za primer
        clickShare(social) {
            const socialButtons = {
                "FB": "",
                "IN": "",
                "TW": "",
                "MAIL": ""
            }
            // primer kode za popup
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.encodedURL}`, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600', "_blank");
            return false;
        }
	},
    filters: {
        capitalize(text) {
            return text.charAt(0).toUpperCase() + text.slice(1)
        },
        date(value) {
            let date = new Date(Date.parse(value))
            return date.toLocaleDateString('sl-SI')
        }
	},
	computed: {
		backUrl() {
            return this.route('blog.index')
        },
        hasGallery() {
            return this.blog && this.blog.gallery && this.blog.gallery.length > 0
        },
        encodedURL() {
            return encodeURIComponent(`https://izzirokus.si/aktualno/${this.blog.permalink}` );
        },
        encodedTitle() {
            return encodeURIComponent(this.blog.title);
        }
    }
};
</script>
